import { render, staticRenderFns } from "./Unknown.vue?vue&type=template&id=230df424&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230df424')) {
      api.createRecord('230df424', component.options)
    } else {
      api.reload('230df424', component.options)
    }
    module.hot.accept("./Unknown.vue?vue&type=template&id=230df424&", function () {
      api.rerender('230df424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/Unknown.vue"
export default component.exports